import { bytesToNDigits } from '@mail/cross-sizes-utils';
import api from 'Cloud/Application/api';
import { path } from 'ramda';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store as reduxStore } from 'reactApp/store';

export const checkUserDataEquals = (oldData) => (newData) => {
    const diffUsed = path(['cloud', 'space', 'bytes_used']);
    const space = path(['cloud', 'space', 'bytes_total']);
    const sizeLimit = path(['cloud', 'file_size_limit']);
    const diffOverquota = path(['cloud', 'space', 'overquota']);

    return (
        space(oldData) !== space(newData) ||
        sizeLimit(newData) !== sizeLimit(oldData) ||
        diffUsed(oldData) !== diffUsed(newData) ||
        diffOverquota(oldData) !== diffOverquota(newData) ||
        oldData.billing_bitmask !== newData.billing_bitmask
    );
};

export const callApi = () => Promise.resolve(api.user());

export const getBaseUploadLimit = () => {
    const state = reduxStore.getState();

    const { uploadLimit } = UserSelectors.getUserData(state);

    return bytesToNDigits(uploadLimit, 3).value;
};
